



























































































































































// base thirs party imports
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

// utils helpers
import mixins, { ExtractVue } from '@/utils/mixins';

// mixins
import componentState from '@/mixins/state';

// models
import { QuoteProductItem } from '@/models/quote';
import { Configuration } from '@/models/configurator/configuration';
import { Module } from '@/models/configurator/module';

// components
import ALDialog from '../core/Dialog/ALDialog.vue';
import ConfigurationFormDialog from '@/components/configurator/ConfigurationFormDialog.vue';
import { roundCurrency } from '@/utils/helpers';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';

type ConfigurationFormDialogType = ExtractVue<typeof ConfigurationFormDialog>;

export default mixins(componentState).extend({
  name: 'QuoteWizardModuleConfigurationDialog',

  components: { ALDialog, ConfigurationFormDialog, ErrorAlert },

  props: {
    onlyAfterMarketParts: Boolean
  },

  data: () => ({
    isFormValid: false,
    moduleDialog: false,
    actionOnLeave: false,
    createForm: true,
    exchangeRate: 1.0,
    currencyCode: 'USD',
    snapshot: undefined as undefined | number,

    product: new QuoteProductItem(),
    loading: false,

    errorMessage: '',
    moduleRules: [(v: string) => !!v || 'Module is required to add a product'],

    closeInProgress: false
  }),

  computed: {
    isConfigured(): boolean {
      return Boolean(this.product.configuration);
    },

    isAccessory(): boolean {
      if (!this.product.module) return false;
      const selectedModule = this.getModuleById(this.product.module);
      return Boolean(selectedModule?.is_accessories);
    },

    showQuantity(): boolean {
      //TODO: client asked to disable showing quantity.
      // However, didn't want to make this permanent (just in case)
      // return !(
      //   this.isAccessory ||
      //   (this.getModuleById(this.product.module!) &&
      //     this.getModuleById(this.product.module!).is_accessories)
      // );
      return false;
    },

    getModuleById: get<(id: number) => Module>(
      'configuratorModule/getModuleById'
    ),

    getConfigurationById: get<(id: number) => Configuration>(
      'configuratorConfiguration/getConfigurationById'
    )
  },

  methods: {
    roundCurrency,

    ...mapActions({
      createConfiguration: 'configuratorConfiguration/createConfiguration',
      fetchConfiguration: 'configuratorConfiguration/fetchConfiguration',
      updateConfiguration: 'configuratorConfiguration/updateConfiguration',
      deleteConfiguration: 'configuratorConfiguration/deleteConfiguration'
    }),

    open(
      productItem: any,
      exchangeRate: number,
      currencyCode: string,
      createForm = true,
      snapshot?: number
    ) {
      try {
        this.exchangeRate = exchangeRate;
        this.currencyCode = currencyCode;
        this.moduleDialog = true;
        this.createForm = createForm;
        this.snapshot = snapshot;
        this.product = productItem ?? new QuoteProductItem();
        this.closeInProgress = false;
        this.setComponentState('loaded');
      } catch (err) {
        this.setComponentState('error', err);
      }
    },

    close() {
      this.closeInProgress = true;
      this.moduleDialog = false;
      this.loading = false;
    },

    saved() {
      // 2023-05-09 - LH - Hack to avoid double clicking calling emit 'save' twice in succession
      // causing product to be added twice
      if (!this.closeInProgress) {
        this.$emit('saved', this.product);
      }

      this.close();
    },

    async tryGetOrFetchConfiguration(configurationId?: number) {
      try {
        if (this.getConfigurationById(Number(configurationId))) {
          return await this.getConfigurationById(Number(configurationId));
        } else {
          return this.fetchConfiguration(configurationId).then(() =>
            this.getConfigurationById(Number(configurationId))
          );
        }
      } catch (e) {
        console.warn('NO CONFIGURAGTION FOUND: ', e);
      }
    },

    async openConfiguration() {
      this.loading = true;

      this.clearAllErrors();

      const quoteConfigurationFormDialog = this.$refs[
        `quoteConfigurationFormDialog`
      ] as ConfigurationFormDialogType;

      if (this.isConfigured) {
        //TODO: LF-2022-12-20 - Pointless code to fetch from server and write back to servere.
        // Potential reason is to update the time stamp of the configuration. But not really required
        this.updateConfiguration(
          await this.tryGetOrFetchConfiguration(this.product.configuration)
        )
          .then(async (configuration: Configuration) => {
            await quoteConfigurationFormDialog
              .open(
                configuration,
                this.product.module!,
                this.exchangeRate,
                this.currencyCode,
                this.isAccessory,
                this.snapshot
              )
              .then(result => {
                this.$set(
                  this.product,
                  'price',
                  // Convert this currency to exchange rate value
                  result.price! * this.exchangeRate
                );
              })
              .catch(() => {
                // Bug fix for uncaught (in promise) that returns a configuration
                return;
              });
          })
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.createConfiguration()
          .then(async (configuration: Configuration) => {
            await quoteConfigurationFormDialog
              .open(
                configuration, //configuration,
                this.product.module!,
                this.exchangeRate,
                this.currencyCode,
                this.isAccessory,
                this.snapshot
              )
              .then(result => {
                this.$set(this.product, 'configuration', result.id);
                this.$set(
                  this.product,
                  'price',
                  // Convert this currency to exchange rate value
                  result.price! * this.exchangeRate
                );
              })
              .catch(failedConfiguration => {
                //TODO: LF-2022-12-20 - We could be unintentially deleting a valid configuration
                this.deleteConfiguration(failedConfiguration.id);
              });
          })
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    clearAllErrors(): void {
      this.errorMessage = '';
    }
  }
});
